import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartBarVert = () => {
  return (
    <g>
      <path d="M0 15.246a.75.75 0 0 1 .75-.75l1.252.001L2 8.954a.95.95 0 0 1 .84-.944l.11-.006H5.5v-3.05a.95.95 0 0 1 .84-.944l.11-.006H9V.954A.95.95 0 0 1 9.84.01l.11-.006h3.1a.95.95 0 0 1 .944.839l.006.11.003 13.544h1.247a.75.75 0 1 1 0 1.5h-1.247V16h-12v-.003H.75a.75.75 0 0 1-.75-.75zM10.5 1.504l.003 12.993h2L12.5 1.504h-2zm-3.5 4 .003 8.993h2L9 5.504H7zm-3.5 4 .003 4.993h2L5.5 9.504h-2z" />
    </g>
  );
};

export default withIcon(IconChartBarVert);
